import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
function PaymentLogoBillie(_ref) {
  var {
      accessibilityLabel,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'PaymentLogoBillie',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 44,
    height: 22,
    viewBox: "0 0 44 22"
  }, props), /*#__PURE__*/React.createElement(Group, {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF4338",
    d: "M1.51752 9.40691H9.78639C10.5085 9.41128 11.2249 9.53486 11.9064 9.77264C12.2939 8.65563 12.4936 7.48249 12.4974 6.3006C12.4974 4.84873 11.9188 3.45634 10.8889 2.42972C9.85903 1.4031 8.46221 0.826346 7.00572 0.826346C5.54924 0.826346 4.1524 1.4031 3.12251 2.42972C2.09262 3.45634 1.51403 4.84873 1.51403 6.3006L1.51752 9.40691ZM1.51752 10.2333V20.8508C7.60017 17.2468 10.3866 13.5491 11.6092 10.5504C11.0239 10.3427 10.4077 10.2343 9.78639 10.2298L1.51752 10.2333ZM2.58451 21.1713H9.77246C10.9943 21.1714 12.1812 20.7651 13.1453 20.017C14.1094 19.2688 14.7956 18.2214 15.0953 17.0407C15.395 15.86 15.291 14.6133 14.7999 13.4981C14.3087 12.3829 13.4584 11.4629 12.3836 10.8837C11.5442 12.9391 10.1092 14.9529 8.1354 16.8845C6.45122 18.5154 4.588 19.9519 2.58102 21.1667L2.58451 21.1713ZM9.77246 21.9931H0.674606V21.6459C0.664129 21.5947 0.664129 21.5419 0.674606 21.4908V6.3006C0.674606 4.62957 1.34053 3.02699 2.52589 1.8454C3.71124 0.66381 5.31893 0 6.99527 0C8.67161 0 10.2793 0.66381 11.4647 1.8454C12.65 3.02699 13.3159 4.62957 13.3159 6.3006C13.3118 7.60012 13.0945 8.89022 12.6727 10.1198C13.9313 10.766 14.9353 11.8155 15.523 13.0993C16.1108 14.3832 16.2482 15.8269 15.9131 17.198C15.5781 18.5692 14.79 19.7881 13.6758 20.6587C12.5615 21.5293 11.1859 22.0009 9.77014 21.9977"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF4338",
    d: "M21.335 12.5487H22.0502C22.1431 12.5487 22.2685 12.5383 22.3823 12.5279C22.4934 12.5143 22.6015 12.4831 22.7027 12.4353C22.7969 12.3849 22.8814 12.3183 22.9523 12.2385C23.02 12.1358 23.0526 12.014 23.0452 11.8913C23.0452 11.6541 22.9616 11.4886 22.813 11.4052C22.5875 11.2961 22.3376 11.2463 22.0873 11.2606H21.3408L21.335 12.5487ZM21.335 10.5812H22.0397C22.2516 10.5952 22.4623 10.5413 22.6412 10.4273C22.7094 10.3762 22.7633 10.3085 22.7976 10.2307C22.832 10.1528 22.8457 10.0675 22.8374 9.98286C22.8446 9.89908 22.8281 9.81495 22.7897 9.74006C22.7513 9.66517 22.6926 9.60253 22.6203 9.55928C22.4142 9.45942 22.1861 9.41323 21.9573 9.42503H21.3141V10.5824L21.335 10.5812ZM20.5374 8.7746H22.2685C22.436 8.77452 22.6029 8.79512 22.7654 8.83594C22.9217 8.86784 23.0699 8.93124 23.2008 9.02227C23.3325 9.10638 23.4394 9.22379 23.5108 9.36253C23.5943 9.5181 23.6344 9.69316 23.6269 9.86945C23.636 10.096 23.5579 10.3175 23.4086 10.4886C23.258 10.6539 23.0642 10.7741 22.849 10.8358V10.8451C23.1098 10.8684 23.3531 10.9862 23.5328 11.1761C23.624 11.2726 23.6948 11.3863 23.7411 11.5105C23.7873 11.6348 23.8081 11.767 23.8022 11.8994C23.8061 12.1146 23.7562 12.3274 23.6571 12.5186C23.5663 12.6835 23.4343 12.8222 23.2739 12.9214C23.1057 13.0266 22.9196 13.1003 22.7247 13.1389C22.5215 13.1885 22.3128 13.2126 22.1036 13.2107H20.4956V8.77575L20.5374 8.7746Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF4338",
    d: "M26.5364 8.77582H25.7388V13.2177H26.5364V8.77582Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF4338",
    d: "M28.6402 8.77582H29.4379V12.514H31.3338V13.2166H28.6402V8.77582Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF4338",
    d: "M32.9813 8.77582H33.7789V12.514H35.6749V13.2166H32.9917V8.77582H32.9813Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF4338",
    d: "M38.1201 8.77582H37.3224V13.2177H38.1201V8.77582Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF4338",
    d: "M40.2238 8.77582H43.1763V9.45749H41.0215V10.5824H43.0626V11.2444H41.0215V12.4932H43.2913V13.1957H40.2343V8.77582H40.2238Z"
  })));
}
PaymentLogoBillie.displayName = 'PaymentLogoBillie';
export default withProvisionalOverrideFromContext(PaymentLogoBillie);
//# sourceMappingURL=index.js.map